import { render } from "./ProductDetail_PenetratingSupervision.vue?vue&type=template&id=3b36dfd0&scoped=true"
import script from "./ProductDetail_PenetratingSupervision.vue?vue&type=script&lang=js"
export * from "./ProductDetail_PenetratingSupervision.vue?vue&type=script&lang=js"

import "./ProductDetail_PenetratingSupervision.vue?vue&type=style&index=0&id=3b36dfd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b36dfd0"]])

export default __exports__